import { Link } from "@tanstack/react-router";
import { Mail } from "lucide-react";
import logoAsset480 from "@/assets/bosque-logo.png.asset.json";
const logoMark = logoAsset480.url;
import { useT, useMedia } from "@/lib/i18n";
import siteConfig from "@/config/site.json";
import navigation from "@/config/navigation.json";

export function Footer() {
  const { tk } = useT();
  const logo = useMedia("brand.logo.mark", logoMark, siteConfig.brand.name);
  return (
    <footer className="bg-primary text-primary-foreground border-t-4 border-gold">
      <div className="max-w-7xl mx-auto px-6 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-1">
          <Link to="/" aria-label={logo.alt} className="flex items-center">
            <img src={logo.url} alt={logo.alt} width={280} height={120} className="h-20 md:h-28 w-auto" loading="lazy" decoding="async" />
          </Link>
          <p className="mt-6 text-sm text-primary-foreground/70 leading-relaxed">
            {tk(siteConfig.brand.tagline_key, siteConfig.brand.tagline_default)}
          </p>
        </div>

        {navigation.footer.columns.map((col) => (
          <div key={col.titleKey}>
            <h3 className="text-xs tracking-[0.3em] uppercase text-gold-soft mb-5 font-display">
              {tk(col.titleKey, col.titleDefault)}
            </h3>
            <ul className="space-y-3 text-sm text-primary-foreground/75">
              {col.items.map((item) => (
                <li key={`${col.titleKey}:${item.to}:${item.labelKey}`}>
                  <Link to={item.to as "/"} className="hover:text-gold-soft">
                    {tk(item.labelKey, item.labelDefault)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div>
          <h3 className="text-xs tracking-[0.3em] uppercase text-gold-soft mb-5 font-display">
            {tk("footer.contacto.title", "Contacto")}
          </h3>
          <ul className="space-y-3 text-sm text-primary-foreground/75">
            {siteConfig.contact.emails.map((e) => (
              <li key={e.address}>
                <a
                  href={`mailto:${e.address}`}
                  className="flex items-center gap-2 hover:text-gold-soft"
                >
                  <Mail size={14} className="text-gold-soft" />
                  <span>{e.address}</span>
                </a>
              </li>
            ))}
            <li>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 mt-2 wood-btn px-4 py-2 text-[10px] tracking-[0.3em] uppercase font-semibold"
              >
                {tk("footer.contacto.cta", "Reserva tu aventura")}
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-foreground/15">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs tracking-[0.2em] uppercase text-primary-foreground/60">
          <span>
            © {new Date().getFullYear()} {siteConfig.brand.name} — {tk("footer.rights", "All rights reserved")}
          </span>
          <span className="flex gap-5 items-center flex-wrap">
            {navigation.footer.legal.map((l) => (
              <Link key={l.labelKey} to={l.to as "/"} className="hover:text-gold-soft">
                {tk(l.labelKey, l.labelDefault)}
              </Link>
            ))}
          </span>
        </div>
      </div>
    </footer>
  );
}
